import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/core';
import t from 'react-translate';
// colors - spacing
import { standardSpacing, halfSpacing } from 'styles/global_defaults/scaffolding';
// redux
import { SkillTagsNormalized } from 'redux/schemas/api/skill-tag';
// components
import { NVBasicTable, SortType } from 'shared/components/nv-basic-table';
import SkillRowModal from './skill-row-modal';
import { getColumns } from './skill-tags-dashboard';

const styles = css`
&.skill-tags{
    padding: 0 ${standardSpacing}px 0 ${standardSpacing}px;
    .skill-row{
      padding: ${halfSpacing}px 0 ${halfSpacing}px 0;
    }
  }
  `;

const SkillsModal = () => {
  const tags = useSelector((state) => state.models.skillTags);
  return (
    <div css={styles} className='skill-tags'>
      <div>
        {t.INSTITUTIONS.SKILL_TAGS.DESCRIPTION()}
      </div>
      <NVBasicTable<JSX.Element, SkillTagsNormalized>
        columns={getColumns()}
        tabledata={tags}
        rowComponent={SkillRowModal as FunctionComponent}
        rowClass='skill-row'
        defaultSort={{ name: 'name', type: SortType.ASC }}
      />
    </div>
  );
};
export default SkillsModal;
